import DiscountsContext from "./DiscountsContext";
import DiscountsContextProvider from './DiscountsContextProvider';

export default DiscountsContext;

export * from './withDiscountsContext';
export {
    DiscountsContextProvider,
};